import {
    setAdtaDeviceDetails,
    fetchAdtaDeviceDetails,
    deleteAdtaDeviceDetails,
    updateAdtaDeviceDetails,
    updateAdtaConfiguration,
    fetchAdtaStatusDetails, updateAdtaDeviceMac,
    updateAdtaMonitoringDetails
} from "../network/AdtaDeviceOverviewNetworkAPI";
import {getTimestampNow} from "../../../util/Util";

export const AdtaDeviceOverviewReducer = (state, action) => {
    switch (action.type) {
        case "RECEIVE_DATA":
            return {...state, ...action.data, loadingOverview: false, timestamp: getTimestampNow()}
        case "LOAD_VIEW":
            fetchAdtaDeviceDetails(action.data.dispatcher)
            return state
        case "LOAD_STATUS":
            fetchAdtaStatusDetails(action.data.dispatcher, state)
            return state
        case "UPDATE_ADTA_CONFIGURATION":
            updateAdtaConfiguration(action.data.dispatcher, action.data.configurations,
                action.data.mac,  action.data.showCustomAlert)
            return state
        case "ADD_DEVICE_DATA":
            setAdtaDeviceDetails(action.data.dispatcher, action.data.stateValues,
                action.data.showCustomAlert)
            return state
        case "UPDATE_DEVICE_DATA":
            updateAdtaDeviceDetails(action.data.dispatcher, action.data.stateValues,
                action.data.showCustomAlert)
            return state
        case "UPDATE_DEVICE_MAC":
            updateAdtaDeviceMac(action.data.dispatcher, action.data.stateValues, action.data.mac,
                action.data.showCustomAlert)
            return state
        case "DELETE_DEVICE_DATA":
            deleteAdtaDeviceDetails(action.data.dispatcher, action.data.mac)
            return state
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        case "UPDATE_MONITORING_DATA":
            updateAdtaMonitoringDetails(action.data.dispatcher, action.data.stateValues,
                action.data.mac)
            return state
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtadevice/reducer/AdtaDeviceOverviewReducer.js